<h2 class="mb-3">{{ "audit.history" | translate }}</h2>

<div fxLayout="column" fxLayoutGap="0.5rem" class="history-collection-container">
  <div fxLayout="column" class="mat-elevation-z2">

    <ng-container *ngIf="auditHistory?.items?.length; else noHistory">
      <table mat-table [dataSource]="auditHistory?.items" multiTemplateDataRows>

        <!-- Acción -->
        <ng-container matColumnDef="action_op">
          <th mat-header-cell *matHeaderCellDef>
            {{ "audit.action" | translate | uppercase }}
          </th>
          <td mat-cell *matCellDef="let h">
            <span
              class="badge"
              [ngClass]="{
                'badge--created': h.action_op === 'created',
                'badge--updated': h.action_op === 'updated',
                'badge--deleted': h.action_op === 'deleted'
              }">
              {{ ('audit.actions.' + h.action_op) | translate }}
            </span>
          </td>
        </ng-container>

        <!-- Usuario -->
        <ng-container matColumnDef="action_user">
          <th mat-header-cell *matHeaderCellDef>
            {{ "audit.user" | translate | uppercase }}
          </th>
          <td mat-cell *matCellDef="let h">
            <mat-icon inline>person</mat-icon>
            <span class="ml-1">{{ h.action_user }}</span>
          </td>
        </ng-container>

        <!-- Propiedades -->
        <ng-container matColumnDef="properties">
          <th mat-header-cell *matHeaderCellDef>
            {{ "audit.properties" | translate | uppercase }}
          </th>
          <td mat-cell *matCellDef="let h">
            <ng-container *ngIf="getDiff(h).length > 0; else noChanges">
              <span *ngFor="let d of getDiff(h)" class="badge badge--neutral">
                {{ d.label | translate }}
              </span>
              <span class="muted">
                ({{ getDiff(h).length }} {{ 'audit.changes' | translate }})
              </span>
            </ng-container>
            <ng-template #noChanges>
              <span class="muted">—</span>
            </ng-template>
          </td>
        </ng-container>

        <!-- Botón expandir -->
        <ng-container matColumnDef="#">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let h" style="width: 50px">
            <div fxLayout="row" fxLayoutAlign="center center">
              <button mat-icon-button (click)="$event.stopPropagation(); expandedElement = expandedElement === h ? null : h">
                <mat-icon class="submenu-button" [ngClass]="{ rotated: expandedElement === h }">expand_more</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <!-- Fila expandida -->
        <ng-container matColumnDef="expandedContainer">
          <td mat-cell *matCellDef="let h" [attr.colspan]="displayedColumns.length">
            <div fxFill
                 [@expandableRow]="h == expandedElement ? 'expanded' : 'collapsed'"
                 class="history-collection-detail-container">
              <div fxLayout="column" fxLayoutGap="0.5rem" class="detail-container" *ngIf="expandedElement === h">
                <mat-card>
                  <mat-card-title>{{ 'audit.detail' | translate }}</mat-card-title>
                  <mat-card-content>
                    <table mat-table [dataSource]="getDiff(h)" class="diff-table">

                      <ng-container matColumnDef="label">
                        <th mat-header-cell *matHeaderCellDef>{{ 'audit.field' | translate }}</th>
                        <td mat-cell *matCellDef="let d">{{ d.label | translate }}</td>
                      </ng-container>

                      <ng-container matColumnDef="before">
                        <th mat-header-cell *matHeaderCellDef>{{ 'audit.before' | translate }}</th>
                        <td mat-cell *matCellDef="let d">
                          <ng-container [ngSwitch]="d.type">
                            <span *ngSwitchCase="'date'">{{ asDate(d.before) | date:'long':'Europe/Madrid' }}</span>
                            <span *ngSwitchCase="'boolean'">{{ d.before ? ('app.actions.yes' | translate) : ('app.actions.no' | translate) }}</span>
                            <span *ngSwitchCase="'enum'">{{ (d.enumPrefix + d.before) | translate | capitalize }}</span>
                            <span *ngSwitchDefault>{{ d.before || '—' }}</span>
                          </ng-container>
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="after">
                        <th mat-header-cell *matHeaderCellDef>{{ 'audit.after' | translate }}</th>
                        <td mat-cell *matCellDef="let d">
                          <ng-container [ngSwitch]="d.type">
                            <span *ngSwitchCase="'date'">{{ asDate(d.after) | date:'long':'Europe/Madrid' }}</span>
                            <span *ngSwitchCase="'boolean'">{{ d.after ? ('app.actions.yes' | translate) : ('app.actions.no' | translate) }}</span>
                            <span *ngSwitchCase="'enum'">{{ (d.enumPrefix + d.after) | translate | capitalize }}</span>
                            <span *ngSwitchDefault>{{ d.after || '—' }}</span>
                          </ng-container>
                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="['label','before','after']"></tr>
                      <tr mat-row *matRowDef="let row; columns: ['label','before','after']"></tr>
                    </table>

                    <div class="mt-2">
                      <button mat-stroked-button color="primary" (click)="$event.stopPropagation(); h.__showRaw = !h.__showRaw">
                        {{ h.__showRaw ? ('audit.hide_raw' | translate) : ('audit.show_raw' | translate) }}
                      </button>
                      <div *ngIf="h.__showRaw" class="mt-2">
                        <pre>{{ h | json }}</pre>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row
            *matRowDef="let element; columns: displayedColumns"
            class="data-element-row"
            [class.data-expanded-row]="expandedElement === element"
            (click)="expandedElement = expandedElement === element ? null : element">
        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedContainer']" class="data-detail-row"></tr>
      </table>
    </ng-container>

    <mat-paginator
      [length]="auditHistory?.total"
      [pageIndex]="auditHistory?.page"
      [pageSize]="auditHistory?.page_size"
      (page)="onChangePage($event)">
    </mat-paginator>
  </div>
</div>

<ng-template #noHistory>
  <p class="mt-3">{{ 'audit.no_history' | translate }}</p>
</ng-template>
